var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66732 1.66683C3.45818 1.66683 1.66732 3.45769 1.66732 5.66683C1.66732 7.87597 3.45818 9.66683 5.66732 9.66683C7.87646 9.66683 9.66732 7.87597 9.66732 5.66683C9.66732 3.45769 7.87646 1.66683 5.66732 1.66683ZM0.333984 5.66683C0.333984 2.72131 2.7218 0.333496 5.66732 0.333496C8.61284 0.333496 11.0007 2.72131 11.0007 5.66683C11.0007 6.8993 10.5826 8.03414 9.88056 8.93726L13.4721 12.5288C13.7324 12.7891 13.7324 13.2112 13.4721 13.4716C13.2117 13.7319 12.7896 13.7319 12.5292 13.4716L8.93775 9.88007C8.03462 10.5821 6.89979 11.0002 5.66732 11.0002C2.7218 11.0002 0.333984 8.61235 0.333984 5.66683ZM3.66732 5.66683C3.66732 5.29864 3.96579 5.00016 4.33398 5.00016H7.00065C7.36884 5.00016 7.66732 5.29864 7.66732 5.66683C7.66732 6.03502 7.36884 6.3335 7.00065 6.3335H4.33398C3.96579 6.3335 3.66732 6.03502 3.66732 5.66683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.ee9f0b29a749552041dfab572b862c6a.svg";
export { ForwardRef as ReactComponent };